"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listGitHubOrganizationPublishedModulesFactory = exports.getNpmModuleUrl = void 0;
/* eslint-disable @typescript-eslint/no-namespace */
var getRepositoriesAsyncIterable_1 = require("./tools/getRepositoriesAsyncIterable");
var url_join_1 = __importDefault(require("url-join"));
var evt_1 = require("evt");
function getNpmModuleUrl(params) {
    var moduleName = params.moduleName;
    return "https://www.npmjs.com/package/" + moduleName;
}
exports.getNpmModuleUrl = getNpmModuleUrl;
function listGitHubOrganizationPublishedModulesFactory(params) {
    var octokit = params.octokit, fetch = params.fetch;
    function listGitHubOrganizationPublishedModules(params) {
        var _this = this;
        var githubOrganizationName = params.githubOrganizationName;
        var getRepositoriesAsyncIterable = getRepositoriesAsyncIterable_1.getRepositoriesAsyncIterableFactory({ octokit: octokit }).getRepositoriesAsyncIterable;
        var repositoryAsyncIterable = getRepositoriesAsyncIterable({
            "org": githubOrganizationName,
        }).repositoryAsyncIterable;
        var evtRepoModules = evt_1.Evt.create();
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var repositoryAsyncIterable_1, repositoryAsyncIterable_1_1, repository, moduleName, e_1_1;
            var _this = this;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, 8, 13]);
                        repositoryAsyncIterable_1 = __asyncValues(repositoryAsyncIterable);
                        _b.label = 1;
                    case 1: return [4 /*yield*/, repositoryAsyncIterable_1.next()];
                    case 2:
                        if (!(repositoryAsyncIterable_1_1 = _b.sent(), !repositoryAsyncIterable_1_1.done)) return [3 /*break*/, 6];
                        repository = repositoryAsyncIterable_1_1.value;
                        return [4 /*yield*/, (function () { return __awaiter(_this, void 0, void 0, function () {
                                var resText;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, fetch(url_join_1.default("https://raw.github.com", repository.full_name, (_a = repository.default_branch) !== null && _a !== void 0 ? _a : "main", "package.json")).then(function (res) { return (res.status !== 404 ? res.text() : undefined); })];
                                        case 1:
                                            resText = _b.sent();
                                            if (resText === undefined) {
                                                return [2 /*return*/, undefined];
                                            }
                                            return [2 /*return*/, JSON.parse(resText)["name"]];
                                    }
                                });
                            }); })()];
                    case 3:
                        moduleName = _b.sent();
                        if (moduleName === undefined) {
                            evtRepoModules.post({
                                "repoName": repository.name,
                                "modules": [],
                            });
                            return [3 /*break*/, 5];
                        }
                        return [4 /*yield*/, fetch(getNpmModuleUrl({ moduleName: moduleName })).then(function (res) { return res.status === 404; })];
                    case 4:
                        if (_b.sent()) {
                            return [3 /*break*/, 5];
                        }
                        evtRepoModules.post({
                            "repoName": repository.name,
                            "modules": [
                                {
                                    "type": "npm",
                                    moduleName: moduleName,
                                    "packageJsonDirPath": "/",
                                },
                            ],
                        });
                        _b.label = 5;
                    case 5: return [3 /*break*/, 1];
                    case 6: return [3 /*break*/, 13];
                    case 7:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 13];
                    case 8:
                        _b.trys.push([8, , 11, 12]);
                        if (!(repositoryAsyncIterable_1_1 && !repositoryAsyncIterable_1_1.done && (_a = repositoryAsyncIterable_1.return))) return [3 /*break*/, 10];
                        return [4 /*yield*/, _a.call(repositoryAsyncIterable_1)];
                    case 9:
                        _b.sent();
                        _b.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        if (e_1) throw e_1.error;
                        return [7 /*endfinally*/];
                    case 12: return [7 /*endfinally*/];
                    case 13:
                        evtRepoModules.post("DONE");
                        return [2 /*return*/];
                }
            });
        }); })();
        return { evtRepoModules: evtRepoModules };
    }
    return { listGitHubOrganizationPublishedModules: listGitHubOrganizationPublishedModules };
}
exports.listGitHubOrganizationPublishedModulesFactory = listGitHubOrganizationPublishedModulesFactory;
//# sourceMappingURL=listGitHubOrganizationPublishedModules.js.map